import ajax from '@/helpers/ajax';
import config from '@/config';
import { router } from '@/router';

const persist = user => localStorage.setItem('osbUser', JSON.stringify(user.data));

const persistIfAuthenticated = (user) => {
  if (user.data.access_token) {
    persist(user);
  }
  return user;
};

const retrieve = () => JSON.parse(localStorage.getItem('osbUser'));

const login = (email, password, brand) => ajax
  .post(config.apiEndpoints.login, { email, password, brand })
  .then(user => persistIfAuthenticated(user));

const logout = () => {
  localStorage.removeItem('osbUser');
};

const gLogin = (token, brand) => ajax
  .post(config.apiEndpoints.loginGoogle, { token, brand })
  .then(user => persistIfAuthenticated(user));

const fbLogin = (token, brand) => ajax
  .post(config.apiEndpoints.loginFacebook, { token, brand })
  .then(user => persistIfAuthenticated(user));

const postLoginRedirect = () => {
  router.push('/dashboard/mycars');
};

export const userService = {
  login,
  gLogin,
  fbLogin,
  logout,
  postLoginRedirect,
  retrieve,
};
